import React, { useState, useContext, useRef } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Grid,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  FormControl,
  Typography,
  Tooltip,
} from "@material-ui/core";
import { FaCaretDown } from "react-icons/fa";
import { IoMdCloseCircle } from "react-icons/io";
import { FiSearch } from "react-icons/fi";
import { LangContext } from "../../Context/Langcontext";
import { UserContext } from "../../Context/UserContext";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyle = makeStyles((theme) => ({
  component: {
    width: "100%",
  },
  grid: {
    display: "flex",
    alignItems: "center",
  },
  paper: {
    boxShadow: "unset",
    borderRadius: 8,
  },
  buttonfilter: {
    whiteSpace: "nowrap",

    backgroundColor: "#E16733",
    color: "#ffffff",
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    "&:hover": {
      backgroundColor: "#E16733",
      color: "#ffffff",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  Textfield: {
    "& .MuiOutlinedInput-input": {
      padding: "11px 14px",
      fontWeight: 200,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderTopRightRadius: 8,
      borderBottomRightRadius: 8,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
  },
  cardStyle: {
    boxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    borderRadius: 8,
  },
  listtext: {
    fontWeight: 200,
    "&:hover": {
      color: "#E16733",
    },
    cursor: "pointer",
  },
  currenttext: {
    fontWeight: 200,
    color: "#E16733",
    cursor: "pointer",
  },
  autocomplete: {
    "& .MuiOutlinedInput-input": {
      fontWeight: 200,
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 1.6,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderTopRightRadius: 8,
      borderBottomRightRadius: 8,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
    "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*=MuiOutlinedInput-root]":
      {
        paddingRight: "unset",
      },
    "& div.MuiChip-root.MuiAutocomplete-tag.MuiChip-deletable": {
      fontWeight: 400,
    },
    "& span.MuiAutocomplete-tag": {
      fontWeight: 400,
    },
    "& .MuiAutocomplete-option[data-selected=true]": {
      fontWeight: 200,
    },
  },
  atc: {
    fontWeight: 200,
  },
}));

const FilterUser = ({ setUserData }) => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const userContext = useContext(UserContext);
  const user = userContext.data;

  const [state, setState] = useState({
    title: `${lang.Name} - ${lang.Lastname}`,
    value: "first_name",
  });
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");
  // const [tags, setTags] = useState([]);
  const [role, setRole] = useState(null);
  const anchorRef = useRef(null);

  const list = [
    { title: `${lang.Name} - ${lang.Lastname}`, value: "first_name" },
    { title: `${lang.Organization}`, value: "organization" },
    { title: `${lang.Type}`, value: "role" },
    // { title: `${lang.Contract}`, value: "contract" },
    // { title: `${lang.Status}`, value: "status" },
  ];

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const Listitem = () => {
    return (
      <Paper className={classes.cardStyle}>
        <ClickAwayListener onClickAway={handleClose}>
          <FormControl component="fieldset" style={{ margin: "1rem" }}>
            {list.map((rs) => {
              return (
                <Typography
                  className={
                    state.title === rs.title
                      ? classes.currenttext
                      : classes.listtext
                  }
                  key={rs.value}
                  onClick={() => {
                    setOpen(false);
                    setState({ ...state, title: rs.title, value: rs.value });
                  }}
                >
                  {rs.title}
                </Typography>
              );
            })}
          </FormControl>
        </ClickAwayListener>
      </Paper>
    );
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const prevOpen = useRef(open);

  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const filterData = () => {
    const data = [...user];
    const filter = data.filter((rs) => {
      let name = `${rs.first_name} ${rs.last_name}`;
      return state.value === "first_name"
        ? name.toLocaleLowerCase().indexOf(value.toLowerCase()) !== -1
        : rs[state.value] !== undefined
        ? rs[state.value].toLocaleLowerCase().indexOf(value.toLowerCase()) !==
          -1
        : "";
    });
    setUserData(filter);
  };

  const filterRole = () => {
    const data = [...user];
    const filterrole = data.filter((rs) => {
      return rs.role === role.value;
    });
    setUserData(filterrole);
  };

  const ResetData = () => {
    setUserData(user);
    setValue("");
  };

  return (
    <Grid container alignItems="center">
      <Grid item xs={12} className={classes.grid}>
        <div className={classes.component}>
          <Grid container>
            <Grid item xs={4}>
              <Tooltip title="เลือกประเภทที่ต้องการค้นหา" placement="top">
                <Button
                  ref={anchorRef}
                  fullWidth
                  className={classes.buttonfilter}
                  endIcon={<FaCaretDown size={24} />}
                  onClick={handleToggle}
                >
                  {state.title}
                </Button>
              </Tooltip>

              <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                placement="bottom-start"
                style={{ zIndex: 50 }}
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === "bottom" ? "center top" : "center bottom",
                    }}
                  >
                    <Listitem />
                  </Grow>
                )}
              </Popper>
            </Grid>
            <Grid item xs={8}>
              <Tooltip
                title={
                  value !== ""
                    ? "ลบข้อความแล้วกด Enter เพื่อทำการรีเซ็ตข้อมูล"
                    : "กรอกข้อความแล้วกด Enter เพื่อทำการค้นหา"
                }
                placement="top"
              >
                {state.value === "role" ? (
                  <Autocomplete
                    id="multiple-role-tags"
                    options={rolelist}
                    onInputChange={(e, v) => {
                      if (v === "") {
                        ResetData();
                      }
                    }}
                    getOptionLabel={(option) => option.title}
                    value={role}
                    onChange={(e, v) => {
                      setRole(v);
                    }}
                    classes={{ paper: classes.atc }}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        if (role !== null) {
                          filterRole();
                        }
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        fullWidth
                        className={classes.autocomplete}
                      />
                    )}
                  />
                ) : (
                  <TextField
                    fullWidth
                    variant="outlined"
                    value={value}
                    onChange={(e) => {
                      setValue(e.target.value);
                    }}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        filterData();
                      }
                    }}
                    className={classes.Textfield}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            style={{ padding: "unset" }}
                            onClick={() => {
                              ResetData();
                            }}
                          >
                            {value !== "" ? <IoMdCloseCircle /> : <FiSearch />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              </Tooltip>
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
};

export default FilterUser;

const rolelist = [
  { title: "Contract", value: "contract" },
  // { title: "Contract user designer", value: "contract_user_designer" },
  // { title: "Officer creator", value: "officer_creator" },
  { title: "Officer", value: "officer" },
  { title: "Public", value: "public" },
];
